export default __webpack_public_path__ + "static/media/pp3.230dcd57.png";